import React from 'react';
import { AlertTriangle } from 'lucide-react';

interface ConcernsListProps {
  concerns: string[];
}

export const ConcernsList: React.FC<ConcernsListProps> = ({ concerns }) => {
  if (!concerns.length) return null;

  return (
    <div className="rounded-lg border border-warning bg-warning-muted/30 p-3 space-y-2">
      <h4 className="text-xs font-semibold text-warning flex items-center gap-1.5">
        <AlertTriangle size={13} />
        Concerns ({concerns.length})
      </h4>
      <ul className="space-y-1">
        {concerns.map((concern, i) => (
          <li key={i} className="flex gap-2 text-sm text-body">
            <span className="text-warning mt-0.5 shrink-0">&#8226;</span>
            <span>{concern}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
